import type { ThemeOptions } from '@mui/material';
import beadedStreamLogo from '../../assets/brandings/beadedStream/beadedStreamLogo.png';
import beadedStreamNavbarLogo from '../../assets/brandings/beadedStream/beadedStreamNavbarLogo.png';

export const beadedStreamTheme: ThemeOptions = {
  assets: {
    logoURL: beadedStreamLogo,
    navbarLogoURL: beadedStreamNavbarLogo,
  },
  palette: {
    primary: { main: '#3a60e9' },
    secondary: { main: '#ffb200' },
    background: {
      default: '#f8fafd',
      paper: '#f8fafd',
    },
    appBarBackground: {
      main: '#3a60e9',
      light: '#3a60e9',
      dark: '#3a60e9',
      contrastText: '#3a60e9',
    },
    appBarText: { main: '#fff' },
  },
};
